import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import { logout } from '../Utils/Utility';
import { Box, Paragraph, Text, /*TextInput,*/ Button } from 'grommet';
/*import Header from './Header';*/
import Footer from './Footer';



class RegistrationResultEbox extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            status: this.props.location.status
        }
        this.redirectHome = this.redirectHome.bind(this);
    }

    componentWillMount() {
        if(this.state.status === 200) {
            sessionStorage.clear();

            var cookies = document.cookie.split(";");
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i];
                var eqPos = cookie.indexOf("=");
                var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
        }
    }

    redirectHome() {
        this.props.history.push('/Home');
    }


    render() {
        const status = this.state.status;
        return (
            <Box>

                <Box direction="column" align='center' className='background-color registration-form'>
                    <Box direction='row' >
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>{status === 200 ? 'Registrazione Ebox ' : <div style={{color:'#E1242B'}}>Si è verificato un errore!</div>}</h1>
                        <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                    </Box>
                    <Box direction='row'>
                        <Paragraph className='textParagraph'>{status === 200 ? "La registrazione all'Ebox è avvenuta con successo. Riesegui la login per aggiornare il tuo profilo." : "La registrazione all'Ebox non è avvenuta. Riprova più tardi"}</Paragraph>
                    </Box>
                    <Box direction='row' margin='xlarge'>
                        {status === 200 ? 
                            <Box className='informativa' align='center' >
                                <Button color='transparent' className='btnform' label='EFFETTUA LA LOGIN' onClick={logout} />
                            </Box>
                        :
                            <Box className='informativa' align='center' >
                                <Button color='transparent' className='btnform' label='VAI ALLA HOME' onClick={this.redirectHome} />
                            </Box>
                        }
                    </Box>
                </Box>
                <Footer />
            </Box >
        )
    }
}


export default RegistrationResultEbox = withRouter(RegistrationResultEbox)